import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Silent } from "@/__main__/data-model.mjs";

export const model = {
  tips: {
    weaknesses: [
      {
        localizedInsights: [
          {
            language: String,
            translation: String,
          },
        ],
        value: Silent(String),
      },
    ],
    strengths: [
      {
        localizedInsights: [
          {
            language: String,
            translation: String,
          },
        ],
        value: Silent(String),
      },
    ],
    insights: [
      {
        localizedInsights: [
          {
            language: String,
            translation: String,
          },
        ],
        value: Silent(String),
      },
    ],
  },
  lastUpdatedPatch: String,
  championId: Number,
} satisfies ModelDefinition;

export interface LolChampionInsights extends FromModel<typeof model> {}

const LolChampionInsightsModel = createModel({
  data: {
    championInsights: [model],
  },
}).transform([model], (data) => data.data.championInsights);

export default LolChampionInsightsModel;
